export default __webpack_public_path__ + "static/IMG_9226-dd91d1734a4f4073796fc47630c66d7d.jpg";